/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useState } from "react";
import {
  isCarrierAccessEnabled,
  isCarrierBridgeEnabled,
} from "@shared/config/featureFlags";
import {
  mapCarrierAccessToServiceItems,
  mapToServiceItems,
  ServiceItem,
} from "../utils/tickets";
import { getPortsAndLag } from "../request/request";

export function useLoadServiceItems(api: any, tenantId: number, enabled: boolean) {
  const [items, setItems] = useState<ServiceItem[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!enabled) {
      setItems([]);
      return;
    }
    let cancelled = false;
    setLoading(true);

    (async () => {
      try {
        const resp = await getPortsAndLag(api, tenantId);
        const data = resp?.data?.data ?? {};
        const combined: ServiceItem[] = [
          ...mapToServiceItems(data.ports, "Port", "port"),
          ...mapToServiceItems(data.internet, "Internet", "internet"),
          ...mapToServiceItems(data.datacenterInterconnect, "DCI", "dci"),
          ...mapToServiceItems(data.cloudConnectivity, "Cloud", "cloud"),
          ...mapToServiceItems(data.fwaas, "FWaaS", "fwaas"),
          ...mapToServiceItems(data.sdwan, "SDWAN", "sdwan"),
          // Behind the Carrier Access switch, like its views (GA since CTX-1089).
          ...(isCarrierAccessEnabled()
            ? mapCarrierAccessToServiceItems(data.carrierAccess)
            : []),
          // BETA until its name and SKU are final (CTX-955): hidden in production.
          ...(isCarrierBridgeEnabled()
            ? mapToServiceItems(data.carrierBridge, "Carrier Bridge", "carrier-bridge")
            : []),
        ];
        if (!cancelled) setItems(combined);
      } catch (e) {
        console.error("Error fetching ports/lags", e);
        if (!cancelled) setItems([]);
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();

    return () => { cancelled = true; };
  }, [api, tenantId, enabled]);

  return { items, loading };
}
